import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20background%20with%20soft%20gradient%20warm%20light%20rays%20and%20subtle%20geometric%20film%20reel%20patterns%2C%20elegant%20and%20sophisticated%20design%2C%20modern%20streaming%20platform%20hero%20backdrop%2C%20artistic%20minimalist%20style&width=1600&height=900&seq=hero-qiezi-bg&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 font-heading">
          发现你的下一部好片
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 md:mb-10 leading-relaxed">
          茄子视频汇集<strong>红桃视频</strong>、<strong>红杏视频</strong>等优质<strong>视频平台</strong>，
          提供<strong>高清免费不缓冲</strong>的极致观影体验，好用<strong>视频网站</strong>一网打尽
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
          <Link
            to="/category/movies"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-film-line mr-2"></i>探索热门电影
          </Link>
          <Link
            to="/category/tv-series"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-white font-medium rounded-lg text-sm border border-white/30 hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-tv-line mr-2"></i>追剧热门推荐
          </Link>
        </div>
      </div>
    </section>
  );
}